export function arrayContainsAll(a, b) {
    return a.every((value) => b.includes(value));
}
export function setIsEqual(a, b) {
    if (a.length !== b.length) {
        return false;
    }
    if (a.length === 0) {
        return true;
    }
    const refSet = new Set(a);
    return b.every((value) => refSet.has(value));
}
export function arrayStartsWith(a, b) {
    if (a.length < b.length) {
        return false;
    }
    for (let i = 0; i < b.length; i++) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
}
export function isDefined(x) {
    return x !== null && x !== undefined;
}
export function toArray(obj) {
    return obj ? [obj] : [];
}
export function ensureArray(obj) {
    return Array.isArray(obj) ? obj : [obj];
}
